"use strict";

var _regeneratorRuntime = require("/Users/enguerrand/Dev/Sandblock/surprise-chain-explorer/client/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/Users/enguerrand/Dev/Sandblock/surprise-chain-explorer/client/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/Users/enguerrand/Dev/Sandblock/surprise-chain-explorer/client/node_modules/@babel/runtime/helpers/classCallCheck");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var axios_1 = require("axios");

var utils = require("../utils");

var ledger_1 = require("../utils/ledger");

var secp256k1_1 = require("secp256k1");

var prefixes = {
  testnet: 'tsand',
  mainnet: 'sand'
};

var SandblockChainClient = function SandblockChainClient() {
  var _this = this;

  var testnet = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

  _classCallCheck(this, SandblockChainClient);

  this.setPrivateKey = function (pk) {
    try {
      _this._keypair = utils.getKeypairFromPrivateKey(pk);
      _this._address = utils.getAccAddress(_this._keypair.publicKey);
      return true;
    } catch (error) {
      return false;
    }
  };

  this.setChainID = function (id) {
    _this._chainId = id;
    return _this._chainId;
  };

  this.setPublicKey = function (pk) {
    if (!_this._keypair) {
      _this._keypair = {
        publicKey: Buffer.from(''),
        privateKey: Buffer.from('')
      };
    }

    _this._keypair.publicKey = pk;
    return _this._keypair;
  };

  this.setAddress = function (address) {
    _this._address = address;
    return _this._address;
  };

  this.createAccount = function () {
    var pk = utils.generatePrivateKey();
    var keypair = utils.getKeypairFromPrivateKey(pk);
    return {
      privateKey: keypair.privateKey.toString('hex'),
      publicKey: keypair.publicKey.toString('hex'),
      address: utils.getAddressFromPrivateKey(keypair.privateKey, _this._prefix).toString()
    };
  };

  this.getAccount =
  /*#__PURE__*/
  _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee() {
    var address,
        data,
        _args = arguments;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            address = _args.length > 0 && _args[0] !== undefined ? _args[0] : _this._address;

            if (address) {
              _context.next = 3;
              break;
            }

            throw new Error('Address is required');

          case 3:
            _context.prev = 3;
            _context.next = 6;
            return _this._cosmosClient.get("accounts/".concat(address.toString()));

          case 6:
            data = _context.sent;
            return _context.abrupt("return", data.data);

          case 10:
            _context.prev = 10;
            _context.t0 = _context["catch"](3);
            return _context.abrupt("return", null);

          case 13:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[3, 10]]);
  }));
  this.getAccountLive =
  /*#__PURE__*/
  _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee2() {
    var address,
        data,
        _args2 = arguments;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            address = _args2.length > 0 && _args2[0] !== undefined ? _args2[0] : _this._address;

            if (address) {
              _context2.next = 3;
              break;
            }

            throw new Error('Address is required');

          case 3:
            _context2.prev = 3;
            _context2.next = 6;
            return _this._cosmosClient.get("auth/accounts/".concat(address.toString()));

          case 6:
            data = _context2.sent;
            return _context2.abrupt("return", data.data);

          case 10:
            _context2.prev = 10;
            _context2.t0 = _context2["catch"](3);
            return _context2.abrupt("return", null);

          case 13:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[3, 10]]);
  }));
  this.getAccountDelegations =
  /*#__PURE__*/
  _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee3() {
    var address,
        data,
        _args3 = arguments;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            address = _args3.length > 0 && _args3[0] !== undefined ? _args3[0] : _this._address;
            _context3.prev = 1;
            _context3.next = 4;
            return _this._cosmosClient.get("staking/delegators/".concat(address.toString(), "/delegations"));

          case 4:
            data = _context3.sent;
            return _context3.abrupt("return", data.data);

          case 8:
            _context3.prev = 8;
            _context3.t0 = _context3["catch"](1);
            return _context3.abrupt("return", null);

          case 11:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3, null, [[1, 8]]);
  }));

  this.getBlocksBetween =
  /*#__PURE__*/
  function () {
    var _ref4 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee4(minheight, maxheight) {
      var data;
      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.prev = 0;
              _context4.next = 3;
              return _this._tendermintClient.get("blockchain?minHeight=".concat(minheight, "&maxHeight=").concat(maxheight));

            case 3:
              data = _context4.sent;
              return _context4.abrupt("return", data.data);

            case 7:
              _context4.prev = 7;
              _context4.t0 = _context4["catch"](0);
              return _context4.abrupt("return", null);

            case 10:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, null, [[0, 7]]);
    }));

    return function (_x, _x2) {
      return _ref4.apply(this, arguments);
    };
  }();

  this.getBlockAtHeight =
  /*#__PURE__*/
  function () {
    var _ref5 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee5(height) {
      var data;
      return _regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              _context5.prev = 0;
              _context5.next = 3;
              return _this._cosmosClient.get("blocks/".concat(height));

            case 3:
              data = _context5.sent;
              return _context5.abrupt("return", data.data);

            case 7:
              _context5.prev = 7;
              _context5.t0 = _context5["catch"](0);
              return _context5.abrupt("return", null);

            case 10:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5, null, [[0, 7]]);
    }));

    return function (_x3) {
      return _ref5.apply(this, arguments);
    };
  }();

  this.getBlockAtHeightLive =
  /*#__PURE__*/
  function () {
    var _ref6 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee6(height) {
      var data;
      return _regeneratorRuntime.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              _context6.prev = 0;
              _context6.next = 3;
              return _this._cosmosClient.get("blocks/".concat(height));

            case 3:
              data = _context6.sent;
              return _context6.abrupt("return", data.data);

            case 7:
              _context6.prev = 7;
              _context6.t0 = _context6["catch"](0);
              return _context6.abrupt("return", null);

            case 10:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6, null, [[0, 7]]);
    }));

    return function (_x4) {
      return _ref6.apply(this, arguments);
    };
  }();

  this.getLastFiftyBlocks =
  /*#__PURE__*/
  _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee7() {
    var data;
    return _regeneratorRuntime.wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            _context7.prev = 0;
            _context7.next = 3;
            return _this._apiClient.get("blocks");

          case 3:
            data = _context7.sent;
            return _context7.abrupt("return", data.data);

          case 7:
            _context7.prev = 7;
            _context7.t0 = _context7["catch"](0);
            return _context7.abrupt("return", null);

          case 10:
          case "end":
            return _context7.stop();
        }
      }
    }, _callee7, null, [[0, 7]]);
  }));
  this.getLatestBlock =
  /*#__PURE__*/
  _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee8() {
    var data;
    return _regeneratorRuntime.wrap(function _callee8$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            _context8.prev = 0;
            _context8.next = 3;
            return _this._apiClient.get("blocks/latest");

          case 3:
            data = _context8.sent;
            return _context8.abrupt("return", data.data);

          case 7:
            _context8.prev = 7;
            _context8.t0 = _context8["catch"](0);
            return _context8.abrupt("return", null);

          case 10:
          case "end":
            return _context8.stop();
        }
      }
    }, _callee8, null, [[0, 7]]);
  }));
  this.getLastFiftyTransactions =
  /*#__PURE__*/
  _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee9() {
    var data;
    return _regeneratorRuntime.wrap(function _callee9$(_context9) {
      while (1) {
        switch (_context9.prev = _context9.next) {
          case 0:
            _context9.prev = 0;
            _context9.next = 3;
            return _this._apiClient.get("transactions");

          case 3:
            data = _context9.sent;
            return _context9.abrupt("return", data.data);

          case 7:
            _context9.prev = 7;
            _context9.t0 = _context9["catch"](0);
            return _context9.abrupt("return", null);

          case 10:
          case "end":
            return _context9.stop();
        }
      }
    }, _callee9, null, [[0, 7]]);
  }));

  this.getTransaction =
  /*#__PURE__*/
  function () {
    var _ref10 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee10(hash) {
      var data;
      return _regeneratorRuntime.wrap(function _callee10$(_context10) {
        while (1) {
          switch (_context10.prev = _context10.next) {
            case 0:
              _context10.prev = 0;
              _context10.next = 3;
              return _this._apiClient.get("transactions/".concat(hash));

            case 3:
              data = _context10.sent;
              return _context10.abrupt("return", data.data);

            case 7:
              _context10.prev = 7;
              _context10.t0 = _context10["catch"](0);
              return _context10.abrupt("return", null);

            case 10:
            case "end":
              return _context10.stop();
          }
        }
      }, _callee10, null, [[0, 7]]);
    }));

    return function (_x5) {
      return _ref10.apply(this, arguments);
    };
  }();

  this.getTransactionLive =
  /*#__PURE__*/
  function () {
    var _ref11 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee11(hash) {
      var data;
      return _regeneratorRuntime.wrap(function _callee11$(_context11) {
        while (1) {
          switch (_context11.prev = _context11.next) {
            case 0:
              _context11.prev = 0;
              _context11.next = 3;
              return _this._cosmosClient.get("txs/".concat(hash));

            case 3:
              data = _context11.sent;
              return _context11.abrupt("return", data.data);

            case 7:
              _context11.prev = 7;
              _context11.t0 = _context11["catch"](0);
              return _context11.abrupt("return", null);

            case 10:
            case "end":
              return _context11.stop();
          }
        }
      }, _callee11, null, [[0, 7]]);
    }));

    return function (_x6) {
      return _ref11.apply(this, arguments);
    };
  }();

  this.getValidatorsSet =
  /*#__PURE__*/
  _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee12() {
    var data;
    return _regeneratorRuntime.wrap(function _callee12$(_context12) {
      while (1) {
        switch (_context12.prev = _context12.next) {
          case 0:
            _context12.prev = 0;
            _context12.next = 3;
            return _this._cosmosClient.get("validatorsets/latest");

          case 3:
            data = _context12.sent;
            return _context12.abrupt("return", data.data);

          case 7:
            _context12.prev = 7;
            _context12.t0 = _context12["catch"](0);
            return _context12.abrupt("return", null);

          case 10:
          case "end":
            return _context12.stop();
        }
      }
    }, _callee12, null, [[0, 7]]);
  }));
  this.getValidators =
  /*#__PURE__*/
  _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee13() {
    var status,
        data,
        _args13 = arguments;
    return _regeneratorRuntime.wrap(function _callee13$(_context13) {
      while (1) {
        switch (_context13.prev = _context13.next) {
          case 0:
            status = _args13.length > 0 && _args13[0] !== undefined ? _args13[0] : 'bonded';
            _context13.prev = 1;
            _context13.next = 4;
            return _this._cosmosClient.get("staking/validators?limit=100000&status=".concat(status));

          case 4:
            data = _context13.sent;
            return _context13.abrupt("return", data.data);

          case 8:
            _context13.prev = 8;
            _context13.t0 = _context13["catch"](1);
            return _context13.abrupt("return", null);

          case 11:
          case "end":
            return _context13.stop();
        }
      }
    }, _callee13, null, [[1, 8]]);
  }));

  this.getValidator =
  /*#__PURE__*/
  function () {
    var _ref14 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee14(address) {
      var data;
      return _regeneratorRuntime.wrap(function _callee14$(_context14) {
        while (1) {
          switch (_context14.prev = _context14.next) {
            case 0:
              _context14.prev = 0;
              _context14.next = 3;
              return _this._cosmosClient.get("staking/validators/".concat(address));

            case 3:
              data = _context14.sent;
              return _context14.abrupt("return", data.data);

            case 7:
              _context14.prev = 7;
              _context14.t0 = _context14["catch"](0);
              return _context14.abrupt("return", null);

            case 10:
            case "end":
              return _context14.stop();
          }
        }
      }, _callee14, null, [[0, 7]]);
    }));

    return function (_x7) {
      return _ref14.apply(this, arguments);
    };
  }();

  this.getValidatorDelegations =
  /*#__PURE__*/
  function () {
    var _ref15 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee15(address) {
      var data;
      return _regeneratorRuntime.wrap(function _callee15$(_context15) {
        while (1) {
          switch (_context15.prev = _context15.next) {
            case 0:
              _context15.prev = 0;
              _context15.next = 3;
              return _this._cosmosClient.get("staking/validators/".concat(address, "/delegations"));

            case 3:
              data = _context15.sent;
              return _context15.abrupt("return", data.data);

            case 7:
              _context15.prev = 7;
              _context15.t0 = _context15["catch"](0);
              return _context15.abrupt("return", null);

            case 10:
            case "end":
              return _context15.stop();
          }
        }
      }, _callee15, null, [[0, 7]]);
    }));

    return function (_x8) {
      return _ref15.apply(this, arguments);
    };
  }();

  this.getValidatorOutstandingRewards =
  /*#__PURE__*/
  function () {
    var _ref16 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee16(address) {
      var data;
      return _regeneratorRuntime.wrap(function _callee16$(_context16) {
        while (1) {
          switch (_context16.prev = _context16.next) {
            case 0:
              _context16.prev = 0;
              _context16.next = 3;
              return _this._cosmosClient.get("distribution/validators/".concat(address, "/outstanding_rewards"));

            case 3:
              data = _context16.sent;
              return _context16.abrupt("return", data.data);

            case 7:
              _context16.prev = 7;
              _context16.t0 = _context16["catch"](0);
              return _context16.abrupt("return", null);

            case 10:
            case "end":
              return _context16.stop();
          }
        }
      }, _callee16, null, [[0, 7]]);
    }));

    return function (_x9) {
      return _ref16.apply(this, arguments);
    };
  }();

  this.getValidatorRewards =
  /*#__PURE__*/
  function () {
    var _ref17 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee17(address) {
      var data;
      return _regeneratorRuntime.wrap(function _callee17$(_context17) {
        while (1) {
          switch (_context17.prev = _context17.next) {
            case 0:
              _context17.prev = 0;
              _context17.next = 3;
              return _this._cosmosClient.get("distribution/validators/".concat(address, "/rewards"));

            case 3:
              data = _context17.sent;
              return _context17.abrupt("return", data.data);

            case 7:
              _context17.prev = 7;
              _context17.t0 = _context17["catch"](0);
              return _context17.abrupt("return", null);

            case 10:
            case "end":
              return _context17.stop();
          }
        }
      }, _callee17, null, [[0, 7]]);
    }));

    return function (_x10) {
      return _ref17.apply(this, arguments);
    };
  }();

  this.getDelegatorDelegations =
  /*#__PURE__*/
  function () {
    var _ref18 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee18(address) {
      var data;
      return _regeneratorRuntime.wrap(function _callee18$(_context18) {
        while (1) {
          switch (_context18.prev = _context18.next) {
            case 0:
              _context18.prev = 0;
              _context18.next = 3;
              return _this._cosmosClient.get("staking/delegators/".concat(address, "/delegations"));

            case 3:
              data = _context18.sent;
              return _context18.abrupt("return", data.data);

            case 7:
              _context18.prev = 7;
              _context18.t0 = _context18["catch"](0);
              return _context18.abrupt("return", null);

            case 10:
            case "end":
              return _context18.stop();
          }
        }
      }, _callee18, null, [[0, 7]]);
    }));

    return function (_x11) {
      return _ref18.apply(this, arguments);
    };
  }();

  this.getAllDelegatorRewards =
  /*#__PURE__*/
  function () {
    var _ref19 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee19(address) {
      var data;
      return _regeneratorRuntime.wrap(function _callee19$(_context19) {
        while (1) {
          switch (_context19.prev = _context19.next) {
            case 0:
              _context19.prev = 0;
              _context19.next = 3;
              return _this._cosmosClient.get("distribution/delegators/".concat(address, "/rewards"));

            case 3:
              data = _context19.sent;
              return _context19.abrupt("return", data.data);

            case 7:
              _context19.prev = 7;
              _context19.t0 = _context19["catch"](0);
              return _context19.abrupt("return", null);

            case 10:
            case "end":
              return _context19.stop();
          }
        }
      }, _callee19, null, [[0, 7]]);
    }));

    return function (_x12) {
      return _ref19.apply(this, arguments);
    };
  }();

  this.getDelegatorWithdrawAddress =
  /*#__PURE__*/
  function () {
    var _ref20 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee20(address) {
      var data;
      return _regeneratorRuntime.wrap(function _callee20$(_context20) {
        while (1) {
          switch (_context20.prev = _context20.next) {
            case 0:
              _context20.prev = 0;
              _context20.next = 3;
              return _this._cosmosClient.get("distribution/delegators/".concat(address, "/withdraw_address"));

            case 3:
              data = _context20.sent;
              return _context20.abrupt("return", data.data);

            case 7:
              _context20.prev = 7;
              _context20.t0 = _context20["catch"](0);
              return _context20.abrupt("return", null);

            case 10:
            case "end":
              return _context20.stop();
          }
        }
      }, _callee20, null, [[0, 7]]);
    }));

    return function (_x13) {
      return _ref20.apply(this, arguments);
    };
  }();

  this.getStatus =
  /*#__PURE__*/
  _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee21() {
    var data;
    return _regeneratorRuntime.wrap(function _callee21$(_context21) {
      while (1) {
        switch (_context21.prev = _context21.next) {
          case 0:
            _context21.prev = 0;
            _context21.next = 3;
            return _this._tendermintClient.get("status");

          case 3:
            data = _context21.sent;
            return _context21.abrupt("return", data.data);

          case 7:
            _context21.prev = 7;
            _context21.t0 = _context21["catch"](0);
            return _context21.abrupt("return", null);

          case 10:
          case "end":
            return _context21.stop();
        }
      }
    }, _callee21, null, [[0, 7]]);
  }));

  this.search =
  /*#__PURE__*/
  function () {
    var _ref22 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee22(query) {
      var data;
      return _regeneratorRuntime.wrap(function _callee22$(_context22) {
        while (1) {
          switch (_context22.prev = _context22.next) {
            case 0:
              _context22.prev = 0;
              _context22.next = 3;
              return _this._apiClient.post("search", JSON.stringify({
                data: query
              }), _this.axiosConfig);

            case 3:
              data = _context22.sent;
              return _context22.abrupt("return", data.data);

            case 7:
              _context22.prev = 7;
              _context22.t0 = _context22["catch"](0);
              return _context22.abrupt("return", null);

            case 10:
            case "end":
              return _context22.stop();
          }
        }
      }, _callee22, null, [[0, 7]]);
    }));

    return function (_x14) {
      return _ref22.apply(this, arguments);
    };
  }();

  this.broadcastRawTransaction =
  /*#__PURE__*/
  function () {
    var _ref23 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee23(signed) {
      var data;
      return _regeneratorRuntime.wrap(function _callee23$(_context23) {
        while (1) {
          switch (_context23.prev = _context23.next) {
            case 0:
              _context23.prev = 0;
              _context23.next = 3;
              return _this._cosmosClient.post("txs", signed);

            case 3:
              data = _context23.sent;
              return _context23.abrupt("return", data.data);

            case 7:
              _context23.prev = 7;
              _context23.t0 = _context23["catch"](0);
              return _context23.abrupt("return", null);

            case 10:
            case "end":
              return _context23.stop();
          }
        }
      }, _callee23, null, [[0, 7]]);
    }));

    return function (_x15) {
      return _ref23.apply(this, arguments);
    };
  }();

  this.dispatchTX =
  /*#__PURE__*/
  function () {
    var _ref24 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee24(signedTx, mode) {
      var broadcastBody;
      return _regeneratorRuntime.wrap(function _callee24$(_context24) {
        while (1) {
          switch (_context24.prev = _context24.next) {
            case 0:
              broadcastBody = utils.createBroadcastBody(signedTx, mode);
              _context24.next = 3;
              return _this.broadcastRawTransaction(broadcastBody);

            case 3:
              return _context24.abrupt("return", _context24.sent);

            case 4:
            case "end":
              return _context24.stop();
          }
        }
      }, _callee24);
    }));

    return function (_x16, _x17) {
      return _ref24.apply(this, arguments);
    };
  }();

  this.dispatch =
  /*#__PURE__*/
  function () {
    var _ref25 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee25(stdTx) {
      var mode,
          account,
          txSignature,
          signedTx,
          _args25 = arguments;
      return _regeneratorRuntime.wrap(function _callee25$(_context25) {
        while (1) {
          switch (_context25.prev = _context25.next) {
            case 0:
              mode = _args25.length > 1 && _args25[1] !== undefined ? _args25[1] : 'block';
              _context25.prev = 1;
              _context25.next = 4;
              return _this.getAccountLive(_this._address.toString());

            case 4:
              account = _context25.sent.result;
              txSignature = utils.sign(stdTx.value, _this._keypair, {
                sequence: account.value.sequence,
                account_number: account.value.account_number,
                chain_id: _this._chainId
              });
              signedTx = utils.createSignedTx(stdTx.value, txSignature);
              _context25.next = 9;
              return _this.dispatchTX(signedTx, mode);

            case 9:
              return _context25.abrupt("return", _context25.sent);

            case 12:
              _context25.prev = 12;
              _context25.t0 = _context25["catch"](1);
              return _context25.abrupt("return", null);

            case 15:
            case "end":
              return _context25.stop();
          }
        }
      }, _callee25, null, [[1, 12]]);
    }));

    return function (_x18) {
      return _ref25.apply(this, arguments);
    };
  }();

  this.initLedgerMetas =
  /*#__PURE__*/
  function () {
    var _ref26 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee26(transport) {
      var path,
          app,
          address,
          _args26 = arguments;
      return _regeneratorRuntime.wrap(function _callee26$(_context26) {
        while (1) {
          switch (_context26.prev = _context26.next) {
            case 0:
              path = _args26.length > 1 && _args26[1] !== undefined ? _args26[1] : [44, 118, 0, 0, 0];
              _context26.prev = 1;

              /* Init Sandblock Ledger App with transport */
              app = new ledger_1.default(transport);
              /* Ensure app is open */

              _context26.next = 5;
              return app.isAppOpen();

            case 5:
              if (_context26.sent) {
                _context26.next = 7;
                break;
              }

              throw new Error("Please open Sandblock App ");

            case 7:
              _context26.next = 9;
              return app.publicKey(path);

            case 9:
              address = _context26.sent;

              /* Generate payload */
              _this.setAddress(utils.getAddressFromPublicKey(address.compressed_pk));

              _this.setPublicKey(address.compressed_pk);

              return _context26.abrupt("return", {
                address: _this._address,
                keypair: _this._keypair
              });

            case 15:
              _context26.prev = 15;
              _context26.t0 = _context26["catch"](1);
              return _context26.abrupt("return", null);

            case 18:
            case "end":
              return _context26.stop();
          }
        }
      }, _callee26, null, [[1, 15]]);
    }));

    return function (_x19) {
      return _ref26.apply(this, arguments);
    };
  }();

  this.dispatchWithLedger =
  /*#__PURE__*/
  function () {
    var _ref27 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee27(stdTx, transport) {
      var path,
          app,
          fromAddress,
          account,
          metadata,
          messageToSign,
          response,
          signature,
          signedTx,
          _args27 = arguments;
      return _regeneratorRuntime.wrap(function _callee27$(_context27) {
        while (1) {
          switch (_context27.prev = _context27.next) {
            case 0:
              path = _args27.length > 2 && _args27[2] !== undefined ? _args27[2] : [44, 118, 0, 0, 0];
              _context27.prev = 1;

              /* Init Sandblock Ledger App with transport */
              app = new ledger_1.default(transport);
              /* Ensure app is open */

              _context27.next = 5;
              return app.isAppOpen();

            case 5:
              if (_context27.sent) {
                _context27.next = 7;
                break;
              }

              throw new Error("Please open Sandblock App ");

            case 7:
              if (!(!_this._address || !_this._keypair)) {
                _context27.next = 9;
                break;
              }

              throw new Error("Please init ledger metas using initLedgerMetas method");

            case 9:
              fromAddress = _this._address.toString();
              _context27.next = 12;
              return _this.getAccountLive(fromAddress);

            case 12:
              account = _context27.sent.result;

              if (account) {
                _context27.next = 15;
                break;
              }

              throw new Error("Can't fetch the account");

            case 15:
              /* Prepare the payload */
              metadata = {
                sequence: account.value.sequence,
                account_number: account.value.account_number,
                chain_id: _this._chainId
              };
              messageToSign = utils.createSignMessage(stdTx.value, metadata);
              /* Sign the message using ledger */

              _context27.next = 19;
              return app.sign(path, messageToSign);

            case 19:
              response = _context27.sent;

              if (!(response.return_code !== 0x9000)) {
                _context27.next = 22;
                break;
              }

              throw new Error("Can't sign payload");

            case 22:
              /* Add the signature on payload */
              signature = utils.createSignature(secp256k1_1.signatureImport(response.signature), _this._keypair.publicKey, metadata);
              signedTx = utils.createSignedTx(stdTx.value, signature);
              _context27.next = 26;
              return _this.dispatchTX(signedTx);

            case 26:
              return _context27.abrupt("return", _context27.sent);

            case 29:
              _context27.prev = 29;
              _context27.t0 = _context27["catch"](1);
              return _context27.abrupt("return", null);

            case 32:
            case "end":
              return _context27.stop();
          }
        }
      }, _callee27, null, [[1, 29]]);
    }));

    return function (_x20, _x21) {
      return _ref27.apply(this, arguments);
    };
  }();

  this.delegate =
  /*#__PURE__*/
  function () {
    var _ref28 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee28(validatorAddress, asset, amount, fee) {
      var memo,
          _args28 = arguments;
      return _regeneratorRuntime.wrap(function _callee28$(_context28) {
        while (1) {
          switch (_context28.prev = _context28.next) {
            case 0:
              memo = _args28.length > 4 && _args28[4] !== undefined ? _args28[4] : 'JS Library';
              return _context28.abrupt("return", utils.buildStdTx([utils.buildDelegate(_this._address.toString(), validatorAddress, {
                denom: asset,
                amount: amount.toString()
              })], fee, memo));

            case 2:
            case "end":
              return _context28.stop();
          }
        }
      }, _callee28);
    }));

    return function (_x22, _x23, _x24, _x25) {
      return _ref28.apply(this, arguments);
    };
  }();

  this.redelegate =
  /*#__PURE__*/
  function () {
    var _ref29 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee29(validatorSrcAddress, validatorDstAddress, asset, amount, fee) {
      var memo,
          _args29 = arguments;
      return _regeneratorRuntime.wrap(function _callee29$(_context29) {
        while (1) {
          switch (_context29.prev = _context29.next) {
            case 0:
              memo = _args29.length > 5 && _args29[5] !== undefined ? _args29[5] : 'JS Library';
              return _context29.abrupt("return", utils.buildStdTx([utils.buildRedelegate(_this._address.toString(), validatorSrcAddress, validatorDstAddress, {
                denom: asset,
                amount: amount.toString()
              })], fee, memo));

            case 2:
            case "end":
              return _context29.stop();
          }
        }
      }, _callee29);
    }));

    return function (_x26, _x27, _x28, _x29, _x30) {
      return _ref29.apply(this, arguments);
    };
  }();

  this.undelegate =
  /*#__PURE__*/
  function () {
    var _ref30 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee30(validatorAddress, asset, amount, fee) {
      var memo,
          _args30 = arguments;
      return _regeneratorRuntime.wrap(function _callee30$(_context30) {
        while (1) {
          switch (_context30.prev = _context30.next) {
            case 0:
              memo = _args30.length > 4 && _args30[4] !== undefined ? _args30[4] : 'JS Library';
              return _context30.abrupt("return", utils.buildStdTx([utils.buildUndelegate(_this._address.toString(), validatorAddress, {
                denom: asset,
                amount: amount.toString()
              })], fee, memo));

            case 2:
            case "end":
              return _context30.stop();
          }
        }
      }, _callee30);
    }));

    return function (_x31, _x32, _x33, _x34) {
      return _ref30.apply(this, arguments);
    };
  }();

  this.transfer =
  /*#__PURE__*/
  function () {
    var _ref31 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee31(toAddress, asset, amount, fee) {
      var memo,
          _args31 = arguments;
      return _regeneratorRuntime.wrap(function _callee31$(_context31) {
        while (1) {
          switch (_context31.prev = _context31.next) {
            case 0:
              memo = _args31.length > 4 && _args31[4] !== undefined ? _args31[4] : 'JS Library';
              return _context31.abrupt("return", utils.buildStdTx([utils.buildSend([{
                amount: amount.toString(),
                denom: asset
              }], _this._address.toString(), toAddress)], fee, memo));

            case 2:
            case "end":
              return _context31.stop();
          }
        }
      }, _callee31);
    }));

    return function (_x35, _x36, _x37, _x38) {
      return _ref31.apply(this, arguments);
    };
  }();

  this.setWithdrawAddress =
  /*#__PURE__*/
  function () {
    var _ref32 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee32(withdrawAddress, fee) {
      var memo,
          _args32 = arguments;
      return _regeneratorRuntime.wrap(function _callee32$(_context32) {
        while (1) {
          switch (_context32.prev = _context32.next) {
            case 0:
              memo = _args32.length > 2 && _args32[2] !== undefined ? _args32[2] : 'JS Library';
              return _context32.abrupt("return", utils.buildStdTx([utils.buildSetWithdrawAddress(_this._address.toString(), withdrawAddress)], fee, memo));

            case 2:
            case "end":
              return _context32.stop();
          }
        }
      }, _callee32);
    }));

    return function (_x39, _x40) {
      return _ref32.apply(this, arguments);
    };
  }();

  this.withdrawReward =
  /*#__PURE__*/
  function () {
    var _ref33 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee33(validatorAddress, fee) {
      var memo,
          _args33 = arguments;
      return _regeneratorRuntime.wrap(function _callee33$(_context33) {
        while (1) {
          switch (_context33.prev = _context33.next) {
            case 0:
              memo = _args33.length > 2 && _args33[2] !== undefined ? _args33[2] : 'JS Library';
              return _context33.abrupt("return", utils.buildStdTx([utils.buildWithdrawDelegatorReward(_this._address.toString(), validatorAddress)], fee, memo));

            case 2:
            case "end":
              return _context33.stop();
          }
        }
      }, _callee33);
    }));

    return function (_x41, _x42) {
      return _ref33.apply(this, arguments);
    };
  }();

  this._prefix = testnet ? prefixes.testnet : prefixes.mainnet;
  this._chainId = 'sandblockchain';
  this._apiClient = axios_1.default.create({
    baseURL: 'http://api.explorer.sandblock.io/api/v1/',
    timeout: 1000
  });
  this._cosmosClient = axios_1.default.create({
    baseURL: 'http://shore.sandblock.io/cosmos/',
    timeout: 1000
  });
  this._tendermintClient = axios_1.default.create({
    baseURL: 'http://shore.sandblock.io/tendermint/',
    timeout: 1000
  });
  this.axiosConfig = {
    headers: {
      'Content-Type': 'application/json;charset=UTF-8',
      'Access-Control-Allow-Origin': '*'
    }
  };
};

exports.default = SandblockChainClient;